import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { GA4_ID, GSC_VERIFICATION, BING_VERIFICATION } from "@/lib/seo";

export function Analytics() {
  const loc = useLocation();

  useEffect(() => {
    if (GA4_ID && window.gtag) {
      window.gtag("event", "page_view", { page_path: loc.pathname + loc.search });
    }
  }, [loc]);

  if (!GA4_ID && !GSC_VERIFICATION && !BING_VERIFICATION) return null;

  return (
    <Helmet>
      {GSC_VERIFICATION && <meta name="google-site-verification" content={GSC_VERIFICATION} />}
      {BING_VERIFICATION && <meta name="msvalidate.01" content={BING_VERIFICATION} />}
      {GA4_ID && <script async src={`https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`} />}
      {GA4_ID && (
        <script>{`window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}window.gtag=gtag;gtag('js',new Date());gtag('config','${GA4_ID}');`}</script>
      )}
    </Helmet>
  );
}
